import axios from '../axios'

const getDetailTeacherApi = async (id) => { 
    return await axios.get("api/admin/teachers/" + id)
}

export default getDetailTeacherApi
